import clsx from "clsx";
import { FC } from "react";

import { Planner } from "./Planner";

import { CoreUserRoleType } from "components/server-types";
import { getSidebarHeaderText } from "helpers/sidebar";
import { AccordionTitle } from "mds/components/AccordionTitle";
import { HorizontalDivider } from "mds/components/HorizontalDivider";
import { IconText } from "mds/components/IconText";
import { useIsMdOrLarger } from "mds/hooks/use-responsive";
import { ContactsIcon } from "mds/icons";
import { CONTENT_SIDEBAR_TAB_NAME } from "utils/urls";

export const PlannerInsert: FC<{ role?: CoreUserRoleType; startOpen?: boolean }> = ({
  role,
  startOpen = false,
}) => {
  const isNarrowScreen = !useIsMdOrLarger();

  const header = (
    <IconText
      className={clsx("font-semibold", !isNarrowScreen && "py-4")}
      iconStart={<ContactsIcon />}
      text={getSidebarHeaderText(CONTENT_SIDEBAR_TAB_NAME.Planner)}
    />
  );

  const body = (
    <>
      <HorizontalDivider className="mb-4" />

      <Planner role={role} shouldLinkSidebar />
    </>
  );

  return (
    <aside className="w-full min-w-[300px] rounded-xl bg-black-tint-97 px-4 pb-1 md:max-w-[400px]">
      {isNarrowScreen ? (
        <AccordionTitle
          collapsedHeaderClassName="w-full justify-between pt-2 pb-1"
          expandedHeaderClassName="w-full justify-between py-2"
          iconDirection="end"
          startOpen={startOpen}
          title={header}
        >
          {body}
        </AccordionTitle>
      ) : (
        <>
          <h4>{header}</h4>
          {body}
        </>
      )}
    </aside>
  );
};
